import { createApp } from 'vue';
import LottieToApngConverter from '@/Components/LottieToApngConverter.vue';
import '@styles/app.css';

createApp(LottieToApngConverter).mount('#lottie-to-apng-converter');
